/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';

export const CREATE_SHORTLIST_REQUEST = 'CREATE_SHORTLIST_REQUEST';
export const CREATE_SHORTLIST_SUCCESS = 'CREATE_SHORTLIST_SUCCESS';
export const CREATE_SHORTLIST_FAILURE = 'CREATE_SHORTLIST_FAILURE';

/**
 * Create action object that is used to create a shortlist with a set of goals.
 *
 * @param {string} token - JWT for request authentification.
 * @param {Object} request - The shortlist object.
 * @param {string} request.needs - Number of talents needed by type.
 *
 * @return {Object}
 */
export const createShortlist = (token, request) => ({
  [API]: {
    endpoint: '/shortlist/create',
    method: 'POST',
    body: request,
    token,
    types: [
      CREATE_SHORTLIST_REQUEST,
      CREATE_SHORTLIST_SUCCESS,
      CREATE_SHORTLIST_FAILURE,
    ],
  },
});

export const GET_SHORTLIST_REQUEST = 'GET_SHORTLIST_REQUEST';
export const GET_SHORTLIST_SUCCESS = 'GET_SHORTLIST_SUCCESS';
export const GET_SHORTLIST_FAILURE = 'GET_SHORTLIST_FAILURE';

/**
 * Create action object that is used to get a shortlist by ID.
 *
 * @param {string} token - JWT for request authentification.
 * @param {string} shortlist_id - ID of a shortlist
 *
 * @return {Object}
 */
export const getShortlist = (token, shortlist_id) => ({
  [API]: {
    endpoint: `/shortlist/${shortlist_id}`,
    method: 'GET',
    token,
    types: [
      GET_SHORTLIST_REQUEST,
      GET_SHORTLIST_SUCCESS,
      GET_SHORTLIST_FAILURE,
    ],
  },
});

export const ADD_TALENT_SHORTLIST_REQUEST = 'ADD_TALENT_SHORTLIST_REQUEST';
export const ADD_TALENT_SHORTLIST_SUCCESS = 'ADD_TALENT_SHORTLIST_SUCCESS';
export const ADD_TALENT_SHORTLIST_FAILURE = 'ADD_TALENT_SHORTLIST_FAILURE';

/**
 * Create action object that is used to add a talent to a shortlist.
 *
 * @param {string} token - JWT for request authentification.
 * @param {string} shortlist_id_or_code - ID of a shortlist
 * @param {string} talent_id - ID of the talent to shortlist.
 *
 * @return {Object}
 */
export const addTalent = (token, shortlist_id_or_code, talent_id) => ({
  [API]: {
    endpoint: `/shortlist/${shortlist_id_or_code}/add/${talent_id}`,
    method: 'POST',
    token,
    types: [
      ADD_TALENT_SHORTLIST_REQUEST,
      ADD_TALENT_SHORTLIST_SUCCESS,
      ADD_TALENT_SHORTLIST_FAILURE,
    ],
  },
});

export const REMOVE_TALENT_SHORTLIST_REQUEST =
  'REMOVE_TALENT_SHORTLIST_REQUEST';
export const REMOVE_TALENT_SHORTLIST_SUCCESS =
  'REMOVE_TALENT_SHORTLIST_SUCCESS';
export const REMOVE_TALENT_SHORTLIST_FAILURE =
  'REMOVE_TALENT_SHORTLIST_FAILURE';

/**
 * Create action object that is used to remove a talent to from a shortlist.
 *
 * @param {string} token - JWT for request authentification.
 * @param {string} shortlist_id - ID of a shortlist
 * @param {string} talent_id - ID of the talent to shortlist.
 *
 * @return {Object}
 */
export const removeTalent = (token, shortlist_id, talent_id) => ({
  [API]: {
    endpoint: `/shortlist/${shortlist_id}/remove/${talent_id}`,
    method: 'POST',
    token,
    types: [
      REMOVE_TALENT_SHORTLIST_REQUEST,
      REMOVE_TALENT_SHORTLIST_SUCCESS,
      REMOVE_TALENT_SHORTLIST_FAILURE,
    ],
  },
});

export const SHOW_SHORTLIST_BASKET = 'SHOW_SHORTLIST_BASKET';

/**
 * Action that shows the shortlist basket.
 *
 * @return {Object}
 */
export const showShortlistBasket = () => ({
  type: SHOW_SHORTLIST_BASKET,
});

export const HIDE_SHORTLIST_BASKET = 'HIDE_SHORTLIST_BASKET';

/**
 * Action that shows the shortlist basket.
 *
 * @return {Object}
 */
export const hideShortlistBasket = () => ({
  type: HIDE_SHORTLIST_BASKET,
});
